import "./style.scss";
import { useRef } from "react";
import { Icon } from "../Icon";

export const Modal = ({ children, onBack, title, onClose }) => {
  const pointerDownOnBackdrop = useRef(false);

  return (
    <div
      className="modal-wrapper"
      onPointerDown={(e) => {
        pointerDownOnBackdrop.current = e.target === e.currentTarget;
      }}
      onPointerUp={(e) => {
        if (pointerDownOnBackdrop.current && e.target === e.currentTarget) onClose();
        pointerDownOnBackdrop.current = false;
      }}
    >
      <div className="modal-container">
        <div className="header">
          <div className="icons-wrapper">
            <div>{onBack && <Icon onClick={onBack}>&#xea40;</Icon>}</div>
            <div>
              <Icon onClick={onClose}>&#xea0f;</Icon>
            </div>
          </div>
          <div className="title">{title}</div>
          <div className="header-separator" />
        </div>
        <div className="content">{children}</div>
      </div>
    </div>
  );
};
